module.exports = __webpack_public_path__ + "static/media/text.1e79b2c4.svg";